
import React, { useEffect } from "react";
import OnboardingWizard from "@/components/onboarding/OnboardingWizard";
import { useOnboardingState } from "@/integrations/supabase/hooks/useOnboardingState";
import ErrorBoundary from "@/components/ErrorBoundary";

interface OnboardingWizardContainerProps {
  open: boolean;
  onClose: () => void;
}

const OnboardingWizardContainer: React.FC<OnboardingWizardContainerProps> = ({ open, onClose }) => {
  const { onboarding, loading, error } = useOnboardingState();

  // Ensure wizard closes when onboarding is completed
  useEffect(() => {
    if (onboarding?.status === "completed") {
      onClose();
    }
  }, [onboarding, onClose]);

  return (
    <ErrorBoundary>
      <OnboardingWizard
        open={open}
        onClose={onClose}
      />
    </ErrorBoundary>
  );
};

export default OnboardingWizardContainer;
